// Implement and register module
// scan every paragraph, check what is the highest font-size, and set it
/*Quill.register('modules/lineheightfix', function(quill, options) {
    
    quill.on('text-change', function() {
      
        let defaultSize = parseInt(quill.root.style["font-size"]);
        if (!defaultSize)
        {
            // then we check style set on stylesheet
            let computStyle = window.getComputedStyle( quill.root );
                    
            if (computStyle)
                defaultSize = parseInt( computStyle.getPropertyValue( "font-size" ) );
        }

        let paragraphs = quill.root.children;
        
        for (let i = 0; i < paragraphs.length; i++)
        {
            let p = paragraphs[i];
            let size = 0;
            for (let j = 0; j < p.childNodes.length; j++)
            {
                let elt = p.childNodes[j];
                if (elt.nodeType != 3) // text node : https://developer.mozilla.org/fr/docs/Web/API/Node/nodeType
                {
                    let eltSize = elt.style["font-size"];
                    if (eltSize)
                        size = Math.max(size, parseInt(eltSize));
                    else
                        size = defaultSize;
                }
                else
                {
                    size = defaultSize;
                }
                    
            }
            p.style["font-size"] = (size < defaultSize) ? (size + "px") : "";

            //p.style["line-height"] = size + "px";
            
        }
    });
});*/